import React, { useState } from "react";
import { Box, Dialog, DialogContent, DialogTitle, IconButton, TextField, Typography } from "@mui/material";
import { Icon } from "@iconify/react";
import GoogleMapWithSearch from "../../GoogleMapWithSearch";

const CenterAddressPicker = ({
  label = "Centre Address",
  required = false,
  value,
  onChange,          // called with (fullDisplayAddress, fullAddressObject)
  error,
  labelFontSize = 14,
  labelFontWeight = 500,
  labelColor = "var(--app-text-muted)",
  fontFamily = "Figtree",
  labelSx = {},
}) => {
  const [open, setOpen] = useState(false);

  const handleAddressSelect = (location) => {
    const fullAddressObj = {
      floor: location.floor,
      area: location.area,
      pincode: location.pincode,
      city: location.city,
      state: location.state,
      country: location.country,
      fulladdress: location.fulladdress,
      latitude: location.latitude,
      longitude: location.longitude,
      district: location.district,
    };

    const fullDisplayAddress = [
      location.floor,
      location.area,
      location.district,
      location.fulladdress,
    ]
      .filter(Boolean)
      .join(", ");

    onChange(fullDisplayAddress, fullAddressObj);
    setOpen(false);
  };
  // const commonInputSx = {
  //   height: "48px",
  //   borderRadius: "8px",
  //   backgroundColor: "var(--app-surface)",
  //   border: "1px solid var(--app-border)",
  //   px: "2px",
  //   fontFamily: "Figtree",

  //   "& .MuiInputBase-input": {
  //     fontSize: "13px",
  //     fontWeight: 400,
  //     color: "var(--app-text)",

  //   },

  //   "& .MuiInputBase-input::placeholder": {
  //     fontSize: "13px",
  //     fontWeight: 400,
  //     color: "var(--app-text-muted)",
  //     opacity: 1,

  //   },

  //   "&.Mui-disabled": {
  //     backgroundColor: "var(--app-surface-2)",
  //     border: "1px solid var(--app-border)",
  //     opacity: 1,
  //     fontSize: "14px",
  //   },

  //   "&.Mui-disabled .MuiInputBase-input": {
  //     color: "var(--app-text-muted)",
  //     WebkitTextFillColor: "var(--app-text-muted)",
  //     fontSize: "14px",
  //   },
  // };

  const commonInputSx = {
    "&.MuiFilledInput-root": {
      height: "48px",
      borderRadius: "8px",
      backgroundColor: "var(--app-surface)",
      border: "1px solid var(--app-border)",

      "&:before": {
        display: "none",
      },

      "&:after": {
        display: "none",
      },

      "&:hover:not(.Mui-disabled):before": {
        display: "none",
      },
    },

    "& .MuiInputBase-input": {
      padding: "12px 14px",
      lineHeight: "24px",
      fontSize: "14px",
      fontWeight: 400,
      color: "var(--app-text)",
      fontFamily: "Figtree",
    },

    "& .MuiInputBase-input::placeholder": {
      color: "var(--app-text-muted)",
      opacity: 1,
      fontSize: "14px",
    },
  };

  return (
    <Box className="form-group">
      {/* Label */}
      {/* Label */}
      {(label) && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: "6px",
          }}
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              color: labelColor,
              fontFamily: "Figtree",
            }}
          >
            {label}
            {required && <span style={{ color: "#d32f2f" }}> *</span>}
          </Typography>
        </Box>
      )}
      {/* Input */}
      <Box sx={{ position: "relative", width: "100%" }}>
        <TextField
          fullWidth
          variant="filled"
          hiddenLabel
          disableUnderline
          sx={{
            "& .MuiFilledInput-root:before, & .MuiFilledInput-root:after": {
              display: "none",
            },

            "& .MuiFilledInput-root:hover:not(.Mui-disabled):before": {
              display: "none",
            },
          }}
          value={value || ""}
          placeholder={`Select ${label}`}
          onClick={() => setOpen(true)}
          error={!!error}
          helperText={error}
          InputProps={{
            readOnly: true,
            disableUnderline: true,
            sx: commonInputSx,
          }}
        />

        <Icon
          icon="mdi:map-marker"
          width="22"
          height="22"
          style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            color: "var(--app-text-muted)",
            pointerEvents: "none",
          }}
        />
      </Box>

      {/* Dialog */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
      >

        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            p: 1,
          }}
        >
          <IconButton
            onClick={() => setOpen(false)}
            size="small"
            sx={{
              color: "#4B4B4B", // same dark grey as logout modal
            }}
          >
            <Icon icon="mdi:close" width="28" height="28" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <GoogleMapWithSearch onAddressChange={handleAddressSelect} />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default CenterAddressPicker;
